<script setup>
import proinfo from "@/components/common/Productinfo.vue";
</script>
<template>
<div>
    <div>
    <v-dialog
        v-model="Gpt"
        fullscreen
        transition="dialog-bottom-transition"
    >
            <v-card
                v-if="mode==1"
                flat
                tile
            >
    
            <v-toolbar
                height = "50px"
                flat
                tile
                dark
                color="#E13533"
            >
                <v-toolbar-title>
                    {{ toolbar_title }}
                </v-toolbar-title>
                <v-spacer>
                </v-spacer>
                <v-tooltip bottom v-if="mode==2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="init"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                            :disabled = "mess_flg"
                        >
                            <v-icon
                            >
                                mdi-head-sync
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>別案作成</span>
                </v-tooltip>
                <v-tooltip bottom v-if="mode==2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="history_back"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                            :disabled = "mess_flg"
                        >
                            <v-icon
                            >
                                mdi-skip-backward
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>条件指定に戻る</span>
                </v-tooltip>

                <v-tooltip bottom v-if="mode!=2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="mode=2"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                            :disabled = "back_flg"
                        >
                            <v-icon
                            >
                                mdi-skip-forward
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>チャットに戻る</span>
                </v-tooltip>


                <v-btn
                    @click="del_query"
                    icon
                    class="mr-4"
                >
                    <v-icon
                    >
                        mdi-delete
                    </v-icon>
                </v-btn>
                <v-btn
                    @click="move"
                >
                    <v-icon
                        left
                    >
                        mdi-pencil
                    </v-icon>
                    編集画面
                </v-btn>
            </v-toolbar>

            <v-card-text
                >
                    <v-row class="message_box mb-5">
                        <v-icon color="blue">mdi-information</v-icon><span class="message">プレスリリースを作成するにあたり、基本的な内容をAIに指示します。以下の質問にお答えください。メニューの<v-icon>mdi-cog</v-icon>から宛名/署名を作成し、Qlipperの企業データベースを紐づけることで初期値の入力を省略することができます。</span>
                    </v-row>
                    <h2 class="heading">会社プロフィール</h2>
                    <v-row>
                        <v-col cols="1">
                            <span class="input-title">会社名</span>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                              v-model="company_name"
                              clearable
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <span class="input-title">代表者名</span>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                              v-model="representative"
                              clearable
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-btn class="input-title"
                                dark
                                color="#E13532"
                                @click="conf_list"
                            >
                                <v-icon
                                >
                                    mdi-cog
                                </v-icon>
                                署名ロード
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="1">
                            <span class="input-title">本社所在地</span>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                              clearable
                              v-model="address"
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <span class="input-title">事業内容</span>
                        </v-col>
                        <v-col >
                            <v-text-field
                              clearable
                              v-model="bizcontent"
                              hide-details="auto"
                              placeholder="出来るだけ具体的に"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="1">
                            <span class="input-title">連絡先</span>
                        </v-col>
                        <v-col cols="7">
                            <v-text-field
                              v-model="contact"
                              clearable
                              placeholder="電話番号やメールアドレス/サイトURLなど"
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <span class="input-title">担当者</span>
                        </v-col>
                        <v-col>
                            <v-text-field
                              clearable
                              v-model="manager"
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-text>
                    <h2 class="heading">発表概要</h2>
                    <v-row>
                        <v-col cols="1">
                            <span class="input-title">テーマ</span>
                        </v-col>
                        <v-col class="pt-0">
                            <v-select
                                :items="thermitem"
                                v-model="therm"
                                class="pt-2"
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="1">
                            <span class="input-title">日程</span>
                        </v-col>
                        <v-col class="pt-0" cols="2">
                            <v-menu
                                v-model="start_date_area"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                z-index="5000000"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                     v-model="start_date"
                                     prepend-icon="mdi-calendar"
                                     readonly
                                     label="開始日"
                                     v-bind="attrs"
                                     v-on="on"
                                   ></v-text-field>
                                 </template>
                                 <v-date-picker
                                   v-model="start_date"
                                   @input="start_date_area = false"
                                   no-title
                                   locale="jp-ja"
                                   :day-format="(date) => new Date(date).getDate()"
                                 ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col class="pt-0" cols="2">
                            <v-menu
                                v-model="end_date_area"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                z-index="5000000"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                     prepend-icon="mdi-calendar"
                                     v-model="end_date"
                                     readonly
                                     label="終了日"
                                     v-bind="attrs"
                                     v-on="on"
                                     :disabled="non_end"
                                   ></v-text-field>
                                 </template>
                                 <v-date-picker
                                   v-model="end_date"
                                   @input="end_date_area = false"
                                    label="終了日"
                                   no-title
                                   locale="jp-ja"
                                   :day-format="(date) => new Date(date).getDate()"
                                 ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col>
                            <v-switch
                              v-model="timed"
                              label="終了日を指定しない"
                              class="mt-0"
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <h2 class="heading">商材情報</h2>
                    <v-row v-if="therm != 'セミナー' && therm != 'イベント'">
                        <v-col cols="2">
                            <span class="input-title">対象商材名称</span>
                        </v-col>
                        <v-col>
                            <v-text-field
                              clearable
                              v-model="product_name"
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn
                                dark
                                color="#E13532"
                                @click="proinfo_open"
                            >
                                <v-icon
                                    left
                                >
                                    mdi-alpha-p-circle-outline
                                </v-icon>
                                商材情報ロード
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <span class="input-title">これはなんですか？</span>
                        </v-col>
                        <v-col>
                            <v-text-field
                              clearable
                              v-model="product_summary"
                              placeholder="商材やセミナーを一言であらわすならば？（50文字程度）"
                              hide-details="auto"
                              dense
                              outlined
                              count="50"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="therm=='キャンペーン' || therm=='イベント' || therm=='セミナー'">
                        <v-col cols="2">
                            <span class="input-title">開催名称</span>
                        </v-col>
                        <v-col cols="5">
                            <v-text-field
                              clearable
                              v-model="event_name"
                              :placeholder="therm + '名称（50文字程度）'"
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <span class="input-title">対象者</span>
                        </v-col>
                        <v-col>
                            <v-text-field
                              clearable
                              v-model="target"
                              :placeholder="therm + 'の対象者を簡単に（50文字程度）'"
                              hide-details="auto"
                              dense
                              outlined
                              count="50"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="therm == 'イベント' || therm == 'セミナー'">
                        <v-col cols="2">
                            <span class="input-title">開催場所</span>
                        </v-col>
                        <v-col>
                            <v-text-field
                              clearable
                              v-model="place"
                              hide-details="auto"
                              dense
                              outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <h2 class="heading">本文構成</h2>
                    <v-row>
                        <v-col cols="2">
                            <span class="input-title">簡単な概要、伝えたいこと</span>
                        </v-col>
                        <v-col>
                            <v-textarea
                                  v-model="summary"
                                  clearable
                                  placeholder="お知らせしたい内容の簡単な説明（100文字程度）"
                                  hide-details="auto"
                                  counter="100"
                                  outlined
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <span class="input-title">文章の構成</span>
                        </v-col>
                        <v-col>
                            <v-textarea
                                v-model="compo"
                                clearable
                                placeholder="文章の構成を箇条書きで書いてください"
                                hide-details="auto"
                                outlined
                                height = "200px"
                                @keyup.enter="compo_list"
                                @compositionstart="composing=true"
                                @focus="compo_init"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions
                    class="pb-5"
                >
                    <v-spacer>
                    </v-spacer>
                    <v-btn
                        @click="Gpt=false"
                    >
                        CANCEL
                    </v-btn>
                    <v-btn
                        @click="init"
                        :disabled = "mess_flg"
                        :loading = "load_flg"
                    >
                        送信
                    </v-btn>
                    <v-spacer>
                    </v-spacer>
                </v-card-actions>

            </v-card>
            <v-card
                v-else-if="mode==2"
                color="white"
            >
            <v-toolbar
                height = "50px"
                flat
                tile
                dark
                color="#E13533"
            >
                <v-toolbar-title>
                    {{ toolbar_title }}
                </v-toolbar-title>
                <v-spacer>
                </v-spacer>
                <v-tooltip bottom v-if="mode==2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="init"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                            :disabled = "mess_flg"
                        >
                            <v-icon
                            >
                                mdi-head-sync
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>別案作成</span>
                </v-tooltip>


                <v-tooltip bottom v-if="mode==2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="history_back"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                            :disabled = "mess_flg"
                        >
                            <v-icon
                            >
                                mdi-skip-backward
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>条件指定に戻る</span>
                </v-tooltip>

                <v-tooltip bottom v-if="mode!=2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="mode=2"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                            :disabled = "back_flg"
                        >
                            <v-icon
                            >
                                mdi-skip-forward
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>チャットに戻る</span>
                </v-tooltip>


                <v-btn
                    @click="del_query"
                    icon
                    class="mr-4"
                >
                    <v-icon
                    >
                        mdi-delete
                    </v-icon>
                </v-btn>
                <v-btn
                    @click="move"
                >
                    編集画面
                </v-btn>
            </v-toolbar>


                <v-card-text
                    class="pt-3"
                >
                    <v-card
                        min-height="calc(100vh - 30vh)"
                        max-height="100vh"
                        class="pt-3 mb-2"
                        flat
                        outlined
                        id="chat"
                        style="align-items:end;display:flex;overflow-y: scroll;background-color:#F7F7F8;"
                    >

                        <v-card-text
                            class="py-2"
                        >
                            <v-list
                                max-height="330px"
                                class="py-0"
                                style="background-color:#F7F7F8;"
                            >
                                <template v-for="item,i in chat_list">
                                <v-list-item 
                                    class="pl-0 mx-1 pr-3 py-2" style="background-color:#F7F7F8;"
                                    :key="i"
                                >
                                    <v-icon
                                        v-if="item.role=='assistant'"
                                        color="#48A47F"
                                    >
                                        mdi-robot
                                    </v-icon>
                                    <div :class="'message_'+item.role" v-html="release_data(item.content)"></div>
                                    <v-sheet
                                        style="background-color:#F7F7F8;"
                                    >
                                        <v-row>
                                            <v-col
                                                class="py-1 px-0"
                                            >
                                                <v-btn
                                                    text
                                                    color="#459F7B"
                                                    outlined
                                                    class="ml-2"
                                                    v-if="item.role=='assistant'"
                                                    @click="set_text(i)"
                                                    :disabled = "mess_flg"
                                                >
                                                    採用
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-sheet>

                                </v-list-item>
                                <v-divider :key="i"></v-divider>
                                </template>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions
                >
                    <v-text-field
                      clearable
                      placeholder="AIに指示を出して修正した別の案を作成できます"
                      hide-details="auto"
                      v-model="message"
                      :value = "message"
                      outlined
                      class="ml-5 mr-5"
                    ></v-text-field>
                    <v-btn
                        class="mr-3"
                        outlined
                        text
                        dark
                        large
                        style="background-color:#E13533;"
                        :disabled = "c_mess_flg"
                        :loading = "mess_flg"
                        @click="message_put"
                    >
                        指示
                    </v-btn>
                </v-card-actions>
            </v-card>
            <proinfo
                ref="pi"
                v-on:setproduct="setpro($event)"
            >
            </proinfo>
    </v-dialog>
    </div>
    <div>
    <v-dialog
        v-model="text_window_flg"
        width="80vw"
    >
        <v-toolbar
                height = "50px"
                flat
                tile
                dark
                color="#E13533"
        >
            <v-toolbar-title>
                {{ text_title }}
            </v-toolbar-title>
            <v-spacer>
            </v-spacer>
            <v-btn
                style="vertical-align:top"
                :disabled="text_lock_flg"
                @click="update_text"
            >
                <v-icon
                >
                    mdi-head-sync
                </v-icon>
                別案追加
            </v-btn>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">

                    <v-btn
                        icon
                        v-on="on"
                        v-bind="attrs"
                        style="vertical-align:top"
                        @click="text_window_flg=false"
                    >
                        <v-icon
                        >
                            mdi-close
                        </v-icon>

                    </v-btn>
                </template>
                <span>閉じる</span>
            </v-tooltip>
        </v-toolbar>
        <v-card
            max-height="80vh"
            class="overflow-y-auto"
        >
        <v-card-text>
            <v-row class="my-0" v-for="cont,index in text_list" :key="index">
                <v-col cols="11">
                    <v-card
                        flat
                        outlined
                    >
                        <v-card-text
                            style="background-color:#F7F7F8;"
                            class="py-2 px-2"
                        >
                            <div class="message_summary">{{ cont.text }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    class="px-0"
                >
                    <v-btn
                        text
                        color="#459F7B"
                        outlined
                        style="margin:5px 0"
                        :disabled="text_lock_flg"
                        @click="set_cont(index)"
                    >
                        採用
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        </v-card>
    </v-dialog>
    </div>
</div>
</template>
<script>
export default  {
    props : ["conf_id",],
    data (){
        return {
            Gpt  : false,
            text_mode   : 1,
            title_list  : [],
            subtitle_list  : [],
            summary_list  : [],
            mode : 1,
            doc_title   : "",
            text_title     : "",
            text_lock_flg : true,
            doc_sub_title   : "",
            text_window_flg : false,
            sub_title_lock_flg : true,
            doc_summary : "",
            summary_lock_flg : true,
            summary_index : null,
            thermitem : ["イベント","新商品","キャンペーン","リニューアル","機能追加","セミナー","お知らせ","その他"],
            start_date_area : false,
            end_date_area : false,
            start_date      : "",
            end_date      : "",
            timed         : false,
            back_flg      : true,
            company_name  : "",
            bizcontent    : "",
            representative : "",
            address       : "",
            summary       : "",
            compo          : "",
            composing     : false,
            manager       : "",
            contact          : "",
            therm          : "",
			product	      : "",
            product_name  : "",
			product_summary:"",
            event_name    : "",
            target        : "",
            place         : "",
            chat_list     : [],
            message          : "",
            mess_flg      : true,
            c_mess_flg      : true,
            load_flg      : false,
        }
    },
    watch :{
        Gpt : async function(){
            if(this.mode==2)return ;
            if(this.conf_id=="" || this.conf_id == null)return;

            var params = new URLSearchParams();
            if(this.Gpt==true)
            {
                this.config_get();
                const axios = require('axios');
                await axios.post("https://qlipper.jp/api/gpt/get_query",params,{withCredentials: true,})
                .then(response => {
                    if(response.data.summary == undefined)
                        return;
                    this.summary = response.data.summary;
                    this.therm = response.data.therm;
                    //this.product=response.data.product.name;
                    //this.product_summary=response.data.product_summary;
                    this.event_name=response.data.event_name;
                    this.target=response.data.target;
                    this.place=response.data.place;
                    this.start_date = response.data.start_date;
                    this.end_date = response.data.end_date;
                    //this.release_text=response.data.release_text;
                    this.timed = response.data.timed;
                    this.place = response.data.place;
                    this.compo = response.data.compo;
                });
				this.product_set();
            }
        },
        conf_id : function(){
            if(this.conf_id != 0 && this.conf_id != null && this.conf_id != undefined)
                this.config_get();
        },
        summary : function(){
            if(this.summary != "" && this.company_name != "" && this.representative != "" && this.address != "" && this.manager != "" && this.contact != "")
                this.mess_flg=false;
            else
                this.mess_flg=true;
        },
        message : function(){
            if(this.message != "")
                this.c_mess_flg=false;
            else
                this.c_mess_flg=true;
        },
        mode : function(){
            if (this.mode != 2)
            {
                return;
            }
            this.$nextTick(function(){
                let elem = document.getElementById("chat");
                elem.scrollTop=elem.scrollHeight;
            });
        },
    },
    computed : {
        product_id : function(){
            return this.$store.getters['doc_info/get_product_id'];
        },
        product_list : function(){
            return this.$store.getters['product_list/get_product'];
        },

        release_text : function(){
            return this.$store.getters['doc_info/get_doc'];
        },
        text_list : function(){
            var text_list = null;
            switch(this.text_mode)
            {
            case 1:
                text_list = this.title_list;
                break;
            case 2:
                text_list = this.subtitle_list;
                break;
            case 3:
                text_list = this.summary_list;
                break;
            default:
                text_list = this.title_list;
                break;
            }
            return text_list;
        },
        non_end : function(){
            return this.timed;
        },
        toolbar_title : function(){
            let title = "";
            switch(this.mode)
            {
            case 1:
                title="プレスリリース自動作成プロパティ";
                break;
            case 2:
                title="GPTと会話して作成する";
                break;
            case 3:
                title="概要作成";
                break;
            default:
                title="プレスリリース自動作成プロパティ";
                break;
            }
            return title;
        },
    },
    methods : {
        update_text : function(){
            switch(this.text_mode)
            {
            case 1:
                this.title_update();
                break;
            case 2:
                this.sub_title_update();
                break;
            case 3:
                this.summary_update();
                break;
            default:
                break;
            }

        },
        set_cont : function(index){
            switch(this.text_mode)
            {
            case 1:
                this.set_title(index);
                break;
            case 2:
                this.set_subtitle(index);
                break;
            case 3:
                this.set_summary(index);
                break;
            default:
                break;
            }
        },
        text_open  : function(window_flg){
            this.text_mode = window_flg;
            switch(window_flg)
            {
            case 1:
                this.text_title = "タイトル作成";
                if(this.title_list.length==0)
                    this.title_update();
                else
                    this.text_window_flg=true;
                break;
            case 2:
                this.text_title = "サブタイトル作成";
                if(this.subtitle_list.length==0)
                    this.sub_title_update();
                else
                    this.text_window_flg=true;
                break;
            case 3:
                this.text_title = "概要作成";
                if(this.summary_list.length==0)
                    this.summary_update();
                else
                    this.text_window_flg=true;
                break;
            default:
                break;
            }
        },
        compo_init : function(){
            if(this.compo == "" || this.compo == null)
            {
                this.compo += "・";
            }
        },
        product_set : function(){
            let ret_pro =  null;
            for(let cnt = 0 ; cnt < this.product_list.length ; cnt++)
            {
                if(this.product_list[cnt].id == this.product_id)
                {
                    ret_pro = this.product_list[cnt];
                    break;
                }
            }
            this.product = ret_pro;
			if(this.product != null)
			{
				this.product_name    = this.product.product_name;
				this.product_summary = this.product.product_summary;
			}
        },
        setpro     : function(data){
            this.$store.commit("doc_info/set_product_id",data.id);
            this.product_set();
        },
        proinfo_open    : function(){
			this.$refs.pi.selected_open(this.product_id);
        },
        compo_list : function(event){
            if(this.composing == true)
            {
                this.composing = false;
                return;
            }
            let textarea = event.target;
            var sentence = textarea.value;
            var len      = sentence.length;
            var pos      = textarea.selectionStart;
            var before   = sentence.substr(0, pos);
            var word     = '・';
            var after    = sentence.substr(pos, len);
            sentence = before + word + after;
            event.target.value = sentence;
            event.target.selectionStart = pos+1;
            event.target.selectionEnd = pos+1;
            return;
        },
        config_get : async function(){
            var params = new URLSearchParams();
            params.append('conf_id', this.conf_id);

            const axios = require('axios');
            await axios.post("https://qlipper.jp/api/release/get_company_4c",params,{withCredentials: true,})
            .then(response => {
                this.company_name = response.data[0].company_name;
                this.representative = response.data[0].representative;
                this.address = response.data[0].address;
                this.manager = response.data[0].manager;
                this.contact = response.data[0].contact;
                this.bizcontent = response.data[0].bizcontent;
            });
        },

        conf_list : function(){
            this.$emit("conflist");
        },
        move        : function(){
            if(this.Gpt==true)
                this.Gpt=false;
            else
                this.Gpt=true;
            
        },
        summary_gen : function(index){
            if(this.summary_index != null && this.summary_index == index)
            {
                this.mode=3;
                return;
            }
            this.summary_index = index;
            this.release_text = this.chat_list[index].content;
            this.get_summary();
        },
        trimComma : function(str) {
            return str.replace(new RegExp("^" + '"' + "+|" + '"' + "+$", "g"),'');
        },

        set_title : function(index)
        {
            this.$store.commit("doc_info/set_ai_title",this.title_list[index].text);
        },
        set_subtitle : function(index)
        {
            this.$store.commit("doc_info/set_ai_sub_title",this.subtitle_list[index].text);
        },
        set_summary : function(index)
        {
            this.$store.commit("doc_info/set_ai_summary",this.summary_list[index].text);
        },
        get_summary   : async function(){
            let url = "https://docs.qlipper.jp/gcal/title";
            let query = {
                "release_text" : this.release_text,
            };
            this.doc_title="";
            this.doc_sub_title="";
            this.doc_summary="";
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            await fetch(url,params)
            .then(async (res) => {
                this.mode=3;
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
                let loop = true;
                while (loop==true) {
                    const { done, value } = await reader.read();
                    if (done)
                    {
                        loop = false;
                        return;
                    }
                    this.doc_title += value;
                }
            });
            url = "https://docs.qlipper.jp/gcal/sub_title";
            query = {
                "doc_title"    : this.doc_title,
                "release_text" : this.release_text,
            };
            params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            await fetch(url,params)
            .then(async (res) => {
                this.mode=3;
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
                let loop = true;
                while (loop==true) {
                    const { done, value } = await reader.read();
                    if (done)
                    {
                        loop = false;
                        return;
                    }
                    this.doc_sub_title += value;
                }
            });

            url = "https://docs.qlipper.jp/gcal/rel_summary";
            query = {
                "release_text" : this.release_text,
            };
            params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            await fetch(url,params)
            .then(async (res) => {
                this.mode=3;
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
                let loop = true;
                while (loop == true) {
                    const { done, value } = await reader.read();
                    if (done)
                    {
                        loop = false;
                        return;
                    }
                    this.doc_summary += value;
                }
            });
            this.text_lock_flg=false;
            this.sub_title_lock_flg=false;
            this.summary_lock_flg=false;
        },
        title_update : async function(){
            let url = "https://docs.qlipper.jp/gcal/title";
            this.title_list.push({text:""});
            let query = {
                "doc_title" : this.title_list[this.title_list.length-1].text,
                "release_text" : this.release_text,
            };
            this.text_lock_flg=true;
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            await fetch(url,params)
            .then(async (res) => {
                if(this.text_window_flg == false)
                    this.text_window_flg=true;
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
                let loop = true;
                while (loop == true) {
                    const { done, value } = await reader.read();
                    if (done)
                    {
                        loop = false;
                        this.title_list[this.title_list.length-1].text = this.trimComma(this.title_list[this.title_list.length-1].text);
                        return;
                    }
                    this.title_list[this.title_list.length-1].text += value;
                }
            });
            this.text_lock_flg=false;
        },
        sub_title_update : async function(){
            let url = "https://docs.qlipper.jp/gcal/subtitle";
            if(this.subtitle_list.length == 0)
                this.subtitle_list.push({text:""});
            let query = {
                "doc_sub_title" : this.subtitle_list[this.subtitle_list.length-1].text,
                "release_text" : this.release_text,
            };
            this.text_lock_flg=true;
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            await fetch(url,params)
            .then(async (res) => {
                if(this.subtitle_list[this.subtitle_list.length-1].text != "")
                {
                    this.subtitle_list.push({text:""});
                }
                if(this.text_window_flg == false)
                    this.text_window_flg=true;
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
                let loop = true;
                while (loop == true) {
                    const { done, value } = await reader.read();
                    if (done)
                    {
                        loop = false;
                        this.subtitle_list[this.subtitle_list.length-1].text = this.trimComma(this.subtitle_list[this.subtitle_list.length-1].text);
                        return;
                    }
                    this.subtitle_list[this.subtitle_list.length-1].text += value;
                }
            });
            this.text_lock_flg=false;
        },
        summary_update : async function(){
            let url = "https://docs.qlipper.jp/gcal/rel_summary";
            this.summary_list.push({text:""});
            let query = {
                "doc_summary" : this.summary_list[this.summary_list.length-1].text,
                "release_text" : this.release_text,
            };
            this.text_lock_flg=true;
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            await fetch(url,params)
            .then(async (res) => {
                if(this.text_window_flg == false)
                    this.text_window_flg=true;
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();

                let loop = true;
                while (loop == true) {
                    const { done, value } = await reader.read();
                    if (done)
                    {
                        loop = false;
                        this.summary_list[this.summary_list.length-1].text = this.trimComma(this.summary_list[this.summary_list.length-1].text);
                        return;
                    }
                    this.summary_list[this.summary_list.length-1].text += value;
                }
            });
            this.text_lock_flg=false;
        },
        GptClose : async function(){
            let query = this.query_gen();
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            let url = "/api/gpt/set_query"
            await fetch(url,params);
            this.Gpt=false;    
        },
        history_back : function(){
            this.mode=1;
            this.mess_flg=false;
            this.load_flg=false;
        },
        del_query : async function(){
            this.start_date_area=false;
            this.end_date_area=false;
            this.start_date="";
            this.end_date="";
            this.timed=false;
            this.company_name="";
            this.representative="";
            this.address="";
            this.summary="";
            this.manager="";
            this.contact="";
            this.bizcontent = "";
            this.therm="";
			/*
            this.product="";
            this.product_summary="";
			*/
            this.event_name="";
            this.target="";
            this.place="";
            this.release_text="";
            this.chat_list=[];

            this.mode=1;
            if(this.conf_id=="" || this.conf_id == null || this.conf_id==undefined)return;
            this.config_get();
        },
        
        open : function(){
            this.Gpt = true;
        },
        release_data : function(data){
            let text = data.replace("追加指示に従ってプレスリリースを変更してください。\n追加指示:\n","");
            //return text.replaceAll("\n","<br>");
			return text;
        },
        message_put : async function(){
            this.chat_list.push({role:"user",content:"追加指示に従ってプレスリリースを変更してください。\n追加指示:\n"+this.message});
            this.message="";
            let prompt_query = this.query_gen();
            let query = {prompt : prompt_query,chat:this.chat_list};
            let url = "https://docs.qlipper.jp/gcal/chat"
            this.get_chat(url,query);
            this.$nextTick(function(){
                let elem = document.getElementById("chat");
                elem.scrollTop=elem.scrollHeight;
            });
        },
        query_gen :function(){
            return {
                "company_name":this.company_name,
                "representative":this.representative,
                "address":this.address,
                "summary":this.summary,
                "manager":this.manager,
                "contact":this.contact,
                "bizcontent":this.bizcontent,
                "therm":this.therm,
                "product":this.product.product_name,
                "product_summary":this.product.product_summary,
                "event_name":this.event_name,
                "target":this.target,
                "place":this.place,
                "timed":this.timed,
                "compo":this.compo,
                "start_date":this.start_date,
                "end_date":this.end_date,
            };
        },
        init : function(){
            this.summary_index = null;
            this.mess_flg=true;
            this.load_flg=true;
            this.back_flg=false;
            let query = this.query_gen();
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            let url = "/api/gpt/set_query"
            fetch(url,params);

            url = "https://docs.qlipper.jp/gcal/init"
            this.chat_list = [];
            this.get_chat(url,query);
            
        },
        get_chat : async function(url,query){
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            this.mess_flg = true;
            await fetch(url,params)
            .then(async (res) => {
                this.mode=2;
                this.chat_list.push({role:"assistant",content:""});
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
                let elem = document.getElementById("chat");
                let loop = true;
                while (loop == true) {
                    if(elem == null)
                        elem = document.getElementById("chat");
                    if(elem != null)
                        elem.scrollTop=elem.scrollHeight;
                    const { done, value } = await reader.read();
                    if (done){
                        loop = false;
                        return;
                    }
                    //this.release_text += value;
                    this.chat_list[this.chat_list.length-1].content += value;
                }
                if(elem == null)
                    elem = document.getElementById("chat");
                if(elem != null)
                    elem.scrollTop=elem.scrollHeight;
            });
            this.mess_flg=false;
        },
        set_text : function(index){
			/*
            let text_list = this.chat_list[index].content.split('\n');
            let return_text = "";
            text_list.forEach((element) => { 
                if(element == "")
                    return_text += "<p>\n</p>";
                else
                    return_text += "<p>" + element + "</p>";
            });
			*/
            let return_text = this.chat_list[index].content;
            this.$store.commit("doc_info/set_ai_doc",return_text);
            this.Gpt=false;
            return;
        },
    },

}
</script>
<style>
.input-title{
    display:flex;
    height:100%;
    justify-content: flex-end;
    align-items:center;
    font-weight:700;
}
.message_box{
    justify-content:center;
    display:flex;
}

.message{
    display : block;
    margin  : 20px 10px auto;
    font-size : 1.3rem;
    color:#a22041;
    line-height: 25px;
    width:90%;
}

.message_assistant{
    display:block;
    width:100%;
    text-align:left;
    line-height: 1.5;
    padding:10px 40px;
    min-height:40px;
    font-size:1.5rem;
}

.message_assistant p{
	margin : 10px 0 auto;
}

.message_user{
    display:block;
    width:100%;
    text-align:right;
    line-height: 1.5;
    padding:10px 40px;
    min-height:40px;
    font-size:1.5rem;
}

.message_summary{
    display:inline-block;
    width:95%;
    line-height: 1.5;
    font-size:1.4rem;
    min-height: 30px;
}

.summary_label{
    font-weight : bold;
    font-size : 1.5rem;
}

.heading {
    display: block;
    padding: 10px;
    border-bottom: solid 1px;
    border-left: solid 5px #E03532;
    margin: 20px 0;
}
</style>
